import { featuredCategories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'feat-shoes-2026': 'https://readdy.ai/api/search-image?query=Artistic%20sneaker%20collection%20flat%20lay%20on%20warm%20terracotta%20surface%2C%20soft%20morning%20sunlight%20through%20leaves%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20earthy%20neutral%20tones%2C%20high%20detail%20textures%2C%20contemporary%20streetwear%20style&width=600&height=400&seq=feat-shoes-new-2026&orientation=landscape',
  'feat-hoodies-2026': 'https://readdy.ai/api/search-image?query=Stylish%20oversized%20hoodies%20and%20sweaters%20in%20neutral%20earth%20tones%20on%20warm%20cream%20background%2C%20soft%20folded%20fabric%2C%20natural%20window%20light%2C%20editorial%20fashion%20photography%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20textile%2C%20cozy%20atmosphere&width=600&height=400&seq=feat-hoodies-new-2026&orientation=landscape',
  'feat-tshirts-2026': 'https://readdy.ai/api/search-image?query=Elegant%20display%20of%20graphic%20t-shirts%20and%20lightweight%20jackets%20in%20soft%20muted%20colors%20on%20warm%20beige%20surface%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20contemporary%20fashion%2C%20high%20detail%20fabric&width=600&height=400&seq=feat-tshirts-new-2026&orientation=landscape',
};

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Featured Product Categories
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            Explore our most popular Sugargoo spreadsheet categories with curated product links
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer ${
                idx === 0 ? 'md:col-span-1' : ''
              }`}
            >
              <div
                className={`relative overflow-hidden ${
                  idx === 0 ? 'aspect-[4/5]' : 'aspect-[3/4]'
                }`}
              >
                <img
                  src={categoryImages[cat.imageSeq]}
                  alt={`${cat.name} - Sugargoo Spreadsheet Category`}
                  title={`Sugargoo Spreadsheet ${cat.name} - Product Lists & Shopping Guide`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Explore
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}